import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_PERSONALARCHIVE_MESSAGES } from './../../shared/constants';

interface IMessage {
  id: string;
  body?: string;
  itemType: string;
  itemTypeName: string;
  itemTypeDisplayName: string;
  createdDate: Date;
  subject: string;
  author: Author;
  isRead: boolean;
  documentId: string;
}

interface Author {
  name: string;
}

interface ISearchMessagesRequest {
  fromDate?: string;
  toDate?: string;
  searchText?: string;
}

interface MessagesResponse extends ApiResponse {
  messagesList: Array<IMessage>;
  callIsSuccess: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessagesListService extends ApiClientService {
  private messageStatus = new Subject<IMessage>();
  private messageDeleted = new Subject<string>();

  constructor(http: HttpClient) {
    super(http, AB_API_PERSONALARCHIVE_MESSAGES);
  }

  public getMessages(maxCount: string): Observable<MessagesResponse> {
    return this.get({ maxCount: maxCount });
  }

  public getMessage(id: string): Observable<MessagesResponse> {
    return this.get({ id: id });
  }

  public getMessagesList(
    request?: ISearchMessagesRequest
  ): Observable<MessagesResponse> {
    return this.get(request);
  }

  public deleteMessage(id: string): Observable<ApiResponse> {
    return this.delete({ id: id });
  }

  public getMessageStatus(): Observable<IMessage> {
    return this.messageStatus.asObservable();
  }

  public publishMessageStatus(message: IMessage): void {
    this.messageStatus.next(message);
  }

  public getDeletedMessage(): Observable<string> {
    return this.messageDeleted.asObservable();
  }

  public publishDeteledMessage(messageId: string): void {
    this.messageDeleted.next(messageId);
  }
}

export { IMessage, ISearchMessagesRequest, MessagesResponse };
